import React, { PropTypes, Component } from 'react'
import acc from 'accounting'

class ListFeeItem extends Component {

  _selectItem = () => {
    const { item, onSelectItem } = this.props
    onSelectItem(item)
  }

  render() {
    const { item, k } = this.props

    return (
      <tr onTouchTap={this._selectItem}>
        <td>{k + 1}.</td>
        <td><code>{item.get('fee_code')}</code></td>
        <td>{item.get('fee_name')}</td>
        <td className="text-right">
          {acc.formatNumber(item.get('amount'), 2)}
        </td>
      </tr>
    )
  }
}

ListFeeItem.propTypes = {
  item: PropTypes.object,
  k: PropTypes.number,
  onSelectItem: PropTypes.func,
}

export default ListFeeItem



// WEBPACK FOOTER //
// ./src/containers/Manage/PaymentSchemes/list-fee-item.js